import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SelectField } from 'components';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { Grid, Button, Autocomplete, TextField, createFilterOptions } from '@mui/material';

import { SetFormState, RunANRValidation } from '../../actions/ANRValidationActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	}
}));

const ANRValidationForm = (props) => {
	const { sites, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const user = useSelector(state => state.session.user);
	const formState = useSelector((state) => state.anrValidationReducer.formState);

	const filterOptions = createFilterOptions({
		limit: 50
	});

	const _onANRValidationClick = () => {
		dispatch(RunANRValidation(formState.sites.map(site => site.value).toString(), user.id));
	};

	const _handleChange = (name, value) => {
		setFormState({
			...formState,
			[name]: value,
		});
	};

	return (
		<div className={classes.fields}>
			<Grid container spacing={2}>
				<Grid item md={6} xs={6}>
					<Autocomplete
						id="sites"
						name="sites"
						hintText="Sites"
						multiple
						options={sites || []}
						value={formState.sites || []}
						getOptionLabel={(option) => `${option.text}`}
						renderInput={(params) => <TextField {...params} label="Sites" variant="outlined" />}
						filterOptions={filterOptions}
						onChange={(event, value) => { _handleChange('sites', value); }}
					/>
				</Grid>
				<Grid item lg={4} xs={4}>
					<Button
						className={classes.agreeButton}
						color="primary"
						onClick={_onANRValidationClick}
						variant="contained"
						size="large"
					>
						Run Validation
					</Button>
				</Grid>
			</Grid>
		</div>
	);
};

ANRValidationForm.propTypes = {
	sites: PropTypes.array.isRequired
};

export default ANRValidationForm;
